import { scCoreModule } from '../core/core.module';
import { scFilterModule } from '../filter/filter.module';
import { CatalogViewNodeComponent } from '../view/catalog/catalog-view-node.component';
import { CatalogViewComponent } from '../view/catalog/catalog-view.component';
import { FrameViewComponent } from '../view/frame-view.component';
import { scFactsModule } from '../facts/facts.module';
import { scStatModule } from '../stat/stat.module';
import { scSharedModule } from '../shared/shared.module';
import { ReportFrameViewComponent } from './report-frame-view.component';
import { ViewComponent } from './view.component';
import { ViewTabsComponent } from './view-tabs.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardNodeComponent } from './dashboard/dashboard-node.component';
import { CardComponent } from './dashboard/card.component';
import { CardAccountComponent } from './dashboard/card-account.component';
import { FilterViewComponent } from './filter-view.component';

export const scViewModule = 'sc-view';

angular.module(scViewModule, [
  scFactsModule,
  scStatModule,
  scCoreModule,
  scFilterModule,
  scSharedModule,
])
  .component('scCatalogViewNode', CatalogViewNodeComponent)
  .component('scCatalogView', CatalogViewComponent)
  .component('scFrameView', FrameViewComponent)
  .component('scReportFrameView', ReportFrameViewComponent)
  .component('scView', ViewComponent)
  .component('scViewTabs', ViewTabsComponent)
  .component('scDashboard', DashboardComponent)
  .component('scDashboardNode', DashboardNodeComponent)
  .component('scCard', CardComponent)
  .component('scCardAccount', CardAccountComponent)
  .component('scFilterView', FilterViewComponent)
;



// WEBPACK FOOTER //
// ./src/view/view.module.js